import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import ProjectHeader from '@project/guest/contents/project-header';
import CastingList   from '@project/contents/casting_list/_casting_list';

//import Summary         from '@project/contents/summary/_summary';
import InfluencerCheck from '@project/guest/contents/influencer_check/_influencer_check';
import Tasks           from '@project/guest/contents/tasks/_tasks';
import Completes       from '@project/guest/contents/tasks/_completes';
import Report          from '@project/guest/contents/report/_report';

import ProjectInfluencer           from '@project/parts/side-influencer/_side-influencer';
import ProjectInsightLogin         from '@project/parts/insight-login/_insight-login';

import ProjectAssignSettingModal   from '@project/modal/assign-setting-modal/_assign-setting-modal';
import ProjectDraftSettingModal    from '@project/modal/draft-setting-modal/_draft-setting-modal';
import ProjectReportCandidateModal from '@project/modal/report-select-modal/_report-select-modal';
import ProjectPostContentsModal    from '@project/modal/post-contents-modal/_post-contents-modal';
import ContentsTab   from 'contents_tab';
// -------------------------------------------------------

class Project extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      tab  : 'workflow'
      //tab  : 'report'
    };
  }
  // -------------------------------------------------------
  
  /*
   * ナビの変更
   */
  changeNavigation(tab) {
    this.setState({ tab: tab });
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;

    let workflow      = data.workflow || {};
    let influencers    = workflow.influencers || {};
    let check_draft    = data.check_draft || [];
    let complete_draft = data.complete_draft || [];

    // 通知件数の取得
    let pop_count = 0;
    for( let i in influencers ){
      let d = influencers[i];
      if( d.status.is_client_check == 1 && d.status.is_client_check_complete == 0 ) pop_count += 1;
    }

    let tabs = [
      //{ id: 'summary',  name: 'サマリー',                 html: <Summary data={data} /> },
      { id: 'workflow', name: '候補者確認', html: <InfluencerCheck data={data} />, pop_count: pop_count },
      { id: 'draft',   name: '下書き確認 ('+ check_draft.length +')',  html: <Tasks data={data} />, pop_mark: (check_draft.length > 0) },
      { id: 'complete',   name: '確認済みの下書き ('+ complete_draft.length +')',  html: <Completes data={data} /> },
      { id: 'casting_list', name: 'キャスティングリスト', html: <CastingList data={data} /> },
      //{ id: 'report',   name: 'レポート',   html: <Report data={data} /> },
    ];
    
    return (
      <div id="project" className="project-guest-mode">
        <ProjectHeader data={data} />
        <ProjectInfluencer data={data} />
        <ProjectInsightLogin data={data} />
        <ProjectAssignSettingModal data={data} />
        <ProjectDraftSettingModal data={data} />
        <ProjectReportCandidateModal data={data} />
        <ProjectPostContentsModal data={data} />
        
        <div className="project-container">
          <ContentsTab tabs={tabs} select={this.state.tab} font_size={16} />
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Project;